import React from 'react'
import Slider from "react-slick";
import './style.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import img3 from '../../src/assests/car1.jpg'
import img4 from '../../src/assests/car2.jpg'
import img5 from '../../src/assests/car3.jpg'
import img6 from '../../src/assests/car4.jpg'
import img1 from '../../src/assests/carous3.webp'
import img2 from '../../src/assests/carous4.webp'
import img7 from '../../src/assests/carous5.webp'
import img8 from '../../src/assests/carous6.webp'


const Slidewrcarous = () => {
    const settings = {
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 2000,
        cssEase: "linear"
      };
  return (
    <div>
      <Slider {...settings}>
          <div className=''>
            <img className='suizimg' src={img1} alt="" />
            </div>
          <div>
            <img className='suizimg' src={img2} alt="" />
          </div>
          <div>
            <img className='suizimg' src={img7} alt="" />
          </div>
          <div>
            <img className='suizimg' src={img8} alt="" />
          </div>
        
         
        </Slider>
    </div>
  )
}

export default Slidewrcarous;